import { createTheme } from '@material-ui/core/styles';

export const mainTheme = createTheme({
  palette: {
    primary: { main: '#111111' },
    secondary: { main: '#f7a600' },
  },
});

export const newBuSTheme = createTheme({
  palette: {
    primary: { main: '#111111' },
    secondary: { main: '#03274a' },
    text: {
      primary: '#2e2e2e',
    },
  },
  typography: {
    fontFamily: ['EB Garamond', 'serif'].join(','),
    fontSize: 16, // Use this to adapt font size. Default is 14
    button: {
      fontFamily: [
        'Gotham A',
        'Gotham B',
        'Helvetica',
        'Arial',
        'sans-serif',
      ].join(','),
      fontWeight: 'bold',
      color: '#03274a',
    },
    h2: {
      fontSize: 36,
    },
    h4: {
      fontStyle: 'italic',
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1440,
      xl: 1920,
    },
  },
});
